import React, { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import userContext from "../../context/users/UserContext";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { t } from "i18next";

import "./ListViewStylesV2.css";
import PageHeader from "../PageHeader";
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import themeContext from "../../context/theme/ThemeContext";
import SortFilterSection from "./SortFilterSection";
import ListViewTableV2 from "./ListViewTableV2";
import SortPopupFilterSection from "./SortPopupFilterSection";
const queryClient = new QueryClient();

const ListViewV2 = (props) => {
  const placeholder =
    props.placeholder == undefined || props.placeholder == null
      ? t("user.username")
      : props.placeholder;
  const headerPagePresent =
    props.heading == undefined || props.heading == null ? false : true;
  const { themeName } = useContext(themeContext);
  const enhancedFilter =
    props.enhancedFilter != undefined && props.enhancedFilter != null
      ? true
      : false;

  return (
    <>
      <div className="main-container-body react-scroll">
        {headerPagePresent && (
          <div className="list-view-page-header">
            <span className="list-view-page-header-text">{props.heading}</span>
          </div>
        )}
        {enhancedFilter ? (
          <SortPopupFilterSection
            sortObj={props.sortObj}
            filterObj={props.filterObj}
            setSortObj={props.setSortObj}
            setFilterObj={props.setFilterObj}
            buttonsTopBar={props.buttonsTopBar}
            sortDropdownOptions={props.sortDropdownOptions}
            setPagination={props.setPagination}
            paginationObj={props.paginationObj}
            placeholder={placeholder}
            firmsListForFilter={props.firmsListForFilter}
            storeFirmsListForFilter={props.storeFirmsListForFilter}
            setStoreFirmsListForFilters={props.setStoreFirmsListForFilters}
            setFirmListForFilters={props.setFirmListForFilters}
            firmList={props.firmList}
            setFirmList={props.setFirmList}
            storeFirmList={props.storeFirmList}
          />
        ) : (
          <SortFilterSection
            sortObj={props.sortObj}
            filterObj={props.filterObj}
            setSortObj={props.setSortObj}
            setFilterObj={props.setFilterObj}
            buttonsTopBar={props.buttonsTopBar}
            sortDropdownOptions={props.sortDropdownOptions}
            setPagination={props.setPagination}
            paginationObj={props.paginationObj}
            placeholder={placeholder}
            firmsListForFilter={props.firmsListForFilter}
            storeFirmsListForFilter={props.storeFirmsListForFilter}
            setStoreFirmsListForFilters={props.setStoreFirmsListForFilters}
            setFirmListForFilters={props.setFirmListForFilters}
            firmList={props.firmList}
            setFirmList={props.setFirmList}
            storeFirmList={props.storeFirmList}
          />
        )}
        <QueryClientProvider client={queryClient}>
          {/* <ListViewTable
                updateCurrentPage={props.updateCurrentPage}
                cacheTime={200}
                fetchFunction={props.fetchDataFunction}
                columns={props.columns}
                filterObj={props.filterObj}
                initialState={{}}
                sortObj={sortObj}
                setSelectedRowObj={props.setSelectedRowObj}
                selectedRowObj={props.selectedRowObj}
                sideBarComponent = {props.sideBarComponent}
                handleUserClick = {props.handleUserClick}
                widthContainer = {props.widthContainer == null || props.widthContainer == undefined ? 
                  "100%": props.widthContainer}
              /> */}

          <ListViewTableV2
            fetchData={props.fetchData}
            columns={props.columns}
            sortObj={props.sortObj}
            filterObj={props.filterObj}
            setPagination={props.setPagination}
            pageIndex={props.paginationObj.pageIndex}
            pageSize={props.paginationObj.pageSize}
            pageIndexFromParent={props.paginationObj.pageIndex}
            handleUserClick={props.handleUserClick}
            uniqueKey={props.uniqueKey}
          />

          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </div>
    </>
  );
};

export default ListViewV2;
